import React from 'react';

import type { Order } from '@src/domains/orders';
import { useTranslate } from '@src/core/hooks';
import {
  CartCouponAffectedProducts,
  CartSummaryTotal,
  SummaryHeaderCard,
  SummaryHeaderProductCount,
  SummaryHeaderTitle,
  SummaryHeaderTitleRow,
  SummaryItemsList,
  SummaryRoot,
} from '@src/features/cart';

import { useOrderSummary } from '../hooks/useOrderSummary';

type OrderSummaryProps = {
  order: Order;
  showItems?: boolean;
  affectedProductsMaxVisible?: number;
};

export const OrderSummary = (props: OrderSummaryProps) => {
  const { order, showItems = true, affectedProductsMaxVisible } = props;
  const { i18n } = useTranslate();
  const summary = useOrderSummary(order);

  return (
    <SummaryRoot data-testid='order-summary'>
      <SummaryHeaderCard>
        <SummaryHeaderTitleRow>
          <SummaryHeaderTitle>{i18n('checkout_order_summary_title')}</SummaryHeaderTitle>
          <SummaryHeaderProductCount>
            {i18n('checkout_cart_summary_products', { count: summary.productCount })}
          </SummaryHeaderProductCount>
        </SummaryHeaderTitleRow>

        <CartSummaryTotal summary={{ ...summary, canManageCoupon: false }} />

        {summary.showAffectedProducts ? (
          <CartCouponAffectedProducts
            productNames={summary.affectedProductNames}
            maxVisible={affectedProductsMaxVisible}
          />
        ) : null}
      </SummaryHeaderCard>

      {showItems ? <SummaryItemsList items={summary.items} /> : null}
    </SummaryRoot>
  );
};

export default OrderSummary;
